class EmployeeConfig {
  static Employee_Notifications_Center_Endpoints = () => ({
    notificationsCenterList: 'notifications/center',
    notificationCenterBell: 'notifications/center/bell',
  })

  static Employee_NotificationsInbox_Endpoints = (id) => ({
    notificationsInbox: 'notifications/inbox',
    notificationsInboxDetails: `notifications/inbox/details/${id}`,
    notificationsInboxRequestHistory: `notifications/inbox/details/${id}/tracking`,
    notificationsInboxActions: `notifications/inbox/${id}`,
    notificationInboxBell: 'notifications/inbox/bell',
    notificationsInboxSelected: `notifications/inbox/${id}/bulk`,
  })

  static Employee_NotificationsActionHistory_Endpoints = () => ({
    notificationsActionHistory: 'action/history',
  })
}

export default EmployeeConfig
